import * as React from "react";
import { IText } from "../../../classes/text";

export interface IRecurrencePatternWeekly_RepeatsEveryDropdown {
	isTwoWayCalendar: boolean;
	onChangeRepeatsEveryXWeeks: (repeatEveryXWeeks: number) => void;
	repeatEveryXWeeks: number;
	text: IText;
}

export const RecurrencePatternWeekly_RepeatsEveryDropdown: React.SFC<IRecurrencePatternWeekly_RepeatsEveryDropdown> = (props) => {

	const minOptionValue = 1;
	const maxOptionValue = props.isTwoWayCalendar ? 30 : 3;
	const txt = props.text.eventViews;

	const getRepeatsEveryDropdownOptions = (minOptionVal: number, maxOptionVal: number) => {
		const repeatsEveryDropdownOptions = [];
		for (let i = minOptionVal; i <= maxOptionVal; i++) {
			repeatsEveryDropdownOptions.push(<option value={i} key={"repEvery" + i.toString()}>{i}</option>);
		}
		return repeatsEveryDropdownOptions;
	};

	const repeatsEveryDropdownOptions = getRepeatsEveryDropdownOptions(minOptionValue, maxOptionValue);

	const onChangeRepeatsEvery = (event: any): void => {
		event.preventDefault();
		const value = event.target.value;
		const intValue = parseInt(value, 10);
		if (Number.isInteger(intValue) && intValue >= minOptionValue && intValue <= maxOptionValue) {
			props.onChangeRepeatsEveryXWeeks(Number(value));
		}
	};

	return (
		<div className="CMS_e_row">
			<div className="CMS_iInline">
				<div className="CMS_title CMS_T6"><label htmlFor="input-repeats-every">{txt.repeatsEvery}:</label></div>
				<div className="CMS_iiFields">
					<div className="CMS_iInlineText">
						<select className="CMS_input CMS_noWidth" id="input-repeats-every" value={props.repeatEveryXWeeks} onChange={onChangeRepeatsEvery}>
							{repeatsEveryDropdownOptions}
						</select>
						<span>{txt.weeks}</span>
					</div>
				</div>
			</div>
		</div>
	);
};
